import { useMutation } from 'react-query';

import { IAddToOrderPayload } from 'src/models/order.model';
import { orderMicroService } from 'src/services';

export interface IBerryCartWriteResponse {
  id: number;
  items: any[];
}

const addBerryItemToCart = async (
  payload: IAddToOrderPayload,
): Promise<IBerryCartWriteResponse> => {
  const response = await orderMicroService.addItemToCart(payload);
  const body = response.data;

  // Confirmed shape: { status: bool, message: string, data: { id, items } | null }
  if (body?.status === false) {
    throw new Error(body.message ?? 'Cart write rejected by Pulse');
  }

  const cartData = body?.data;

  // data is null on rejected writes; id must be present for a real cart
  if (!cartData?.id) {
    throw new Error(
      `Pulse cart write returned no cart id (data=${JSON.stringify(cartData)})`,
    );
  }

  return { id: cartData.id, items: cartData.items ?? [] };
};

export default function useBerryAddToCart() {
  return useMutation(addBerryItemToCart);
}
